module.exports = __webpack_public_path__ + "img/ico_logout--bl.20ff7545.svg";